import {ChangeDetectionStrategy, Component} from '@angular/core';


@Component({
    selector: 'app-accounting-reports',
    template: '<app-reports-view category="Accounting"></app-reports-view>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountingReportsComponent {

    constructor() {
    }
}
